<template>
	<v-text-field
		:label="$t('login.captcha')"
		:outlined="config.outlined"
		type="text"
		prepend-icon="mdi-cube"
		v-model="captchainput"
		:value="captchainput"
		@input="$emit('input', captchainput)"
	>
		<template v-slot:append>
			<div class="d-flex align-center justify-center">
				<v-img :src="captchaimg" id="captchaimg" @click="refresh" />
				<v-btn
					@click="refresh"
					text
					small
					class="px-0"
					style="width: 30px; min-width: 30px !important"
				>
					<v-icon>mdi-reload</v-icon>
				</v-btn>
			</div>
		</template>
	</v-text-field>
</template>

<script>
export default {
	props: {
		value: { type: String, default: '' },
		config: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			captchainput: null,
			captchaimg: ''
		}
	},
	mounted() {
		this.refresh()
	},
	methods: {
		refresh() {
			this.$api.auth.refreshCaptcha((res) => {
				this.captchaimg = res
			})
		}
	}
}
</script>
